export default function Footer() {
  return (
    <footer className="text-white px-6 py-12 bg-maven-gray-800">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-16">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <img
            src="/maven-logo.svg"
            alt="Maven"
            className="brightness-0 invert"
            style={{ height: "156px" }}
          />
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col items-center md:items-start gap-1">
          <h3 className="text-xl font-bold">Maven</h3>
          <p className="text-sm text-white max-w-md text-center md:text-left">
            Leading with strategy, delivering with excellence, and partnering with purpose—because great healthcare marketing changes lives.
          </p>
          <div className="flex items-center gap-4 mt-4 self-center md:self-end">
            <a
              href="https://mavenmm.com"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-sm border border-white rounded-full text-white hover:bg-white/10 transition-colors"
            >
              Maven Website
            </a>
            <a
              href="https://www.linkedin.com/company/maven-collective-marketing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/70 transition-colors"
              aria-label="LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6"
              >
                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
